export const SOCIAL_PROOF_STATS = [
  { value: 135, suffix: 'B', prefix: '$', label: 'Digital coupon market by 2030' },
  { value: 93.5, suffix: '%', prefix: '', label: 'Consumers use mobile coupons' },
  { value: 30, suffix: '%', prefix: '', label: 'Higher conversion with geo-deals' },
  { value: 17, suffix: '%', prefix: '', label: 'Traffic drop without promotions' },
] as const;

export interface HowItWorksStep {
  number: number;
  title: string;
  description: string;
  icon: 'bell' | 'running' | 'scan' | 'piggy';
}

export const HOW_IT_WORKS_STEPS: HowItWorksStep[] = [
  {
    number: 1,
    title: 'Get Notified',
    description: 'A nearby store drops a flash deal. Your phone buzzes with the discount and countdown.',
    icon: 'bell',
  },
  {
    number: 2,
    title: 'Race There',
    description: 'The discount decays every minute. The faster you arrive, the bigger your savings.',
    icon: 'running',
  },
  {
    number: 3,
    title: 'Scan & Claim',
    description: 'Show the QR code at the register. The current discount locks in at the moment you scan.',
    icon: 'scan',
  },
  {
    number: 4,
    title: 'Save Big',
    description: 'Walk out paying less than everyone who came after you. Speed literally saves money.',
    icon: 'piggy',
  },
];

export const SHOPPER_FEATURES = [
  {
    title: 'Real-Time Deals Nearby',
    description: 'See flash sales from stores within walking or driving distance, right when they drop.',
  },
  {
    title: 'Bigger Savings for Speed',
    description: 'Arrive early and lock in the highest discount tier. Every minute counts.',
  },
  {
    title: 'One-Tap Claim',
    description: 'No printing, no codes to remember. Just show your phone screen at checkout.',
  },
  {
    title: 'Limited Slots',
    description: 'Each deal has a cap on claims. When slots fill up, the deal is done — first come, first served.',
  },
];

export const MERCHANT_FEATURES = [
  {
    title: 'Drive Foot Traffic On Demand',
    description: 'Quiet afternoon? Drop a flash deal and watch shoppers race to your door.',
  },
  {
    title: 'Control Your Margins',
    description: 'Set your own decay curve, duration, and slot limit. You decide the discount, not a platform.',
  },
  {
    title: 'Verified Redemptions',
    description: 'QR-based claims mean no coupon fraud, no screenshots shared. One claim per customer.',
  },
  {
    title: 'Real-Time Analytics',
    description: 'Track views, claims, foot traffic, and conversion rates per deal in your dashboard.',
  },
];

export const FOOTER_LINKS = {
  product: [
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'For Shoppers', href: '#shoppers' },
    { label: 'For Merchants', href: '#merchants' },
  ],
  company: [
    { label: 'About', href: '#' },
    { label: 'Careers', href: '#' },
    { label: 'Blog', href: '#' },
  ],
  legal: [
    { label: 'Privacy Policy', href: '#' },
    { label: 'Terms of Service', href: '#' },
  ],
};
